module.exports = __webpack_public_path__ + "static/media/img_finance.f4e31bf2.gif";